import { colors } from "./colors";

export const effects = {
  popover:
    "0px 4px 8px 0px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08)",
  buttonAction: "0px 0px 0px 1px #5E3CEA, 0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  buttonActionBlack:
    "0px 0px 0px 1px #111111, 0px 1px 1px 0px rgba(0, 0, 0, 0.10)",
  buttonPrimary: `0px 1px 1px 0px rgba(0, 0, 0, 0.10) ,0px 0px 0px 1px ${colors.greyBorder};`,
  brandColoredBoxShadow: `0px 1px 1px 0px rgba(0, 0, 0, 0.10), 0px 0px 0px 1px ${colors.ctaSecondaryOne};`,
  deleteButton: `0px 0px 0px 1px #B21024, 0px 1px 1px 0px rgba(0, 0, 0, 0.10);`,
  modal: `0px 2px 24px 0px rgba(3, 7, 18, 0.08), 0px 16px 32px 0px rgba(3, 7, 18, 0.08), 0px 0px 0px 1px ${colors.greyBorder}, 0px 2px 24px 0px rgba(3, 7, 18, 0.08);`,
  label: `0px 0px 0px 1px ${colors.greyBorder}, 0px 0px 0px 1px ${colors.white} inset, 0px 0px 0px 1.25px ${colors.greyBorder} inset`,
  cardRest:
    "0px 2px 4px 0px rgba(0, 0, 0, 0.06), 0px 0px 0px 1px rgba(0, 0, 0, 0.08)",
};
